// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1g4WA","active":"NavigationItem_active__q-yWp"};